import { render, staticRenderFns } from "./EditPropertyButton.vue?vue&type=template&id=0be1439b&"
import script from "./EditPropertyButton.vue?vue&type=script&lang=js&"
export * from "./EditPropertyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports